import { axiosBaseQuery } from './axiosBaseQuery'
import { createApi, retry } from '@reduxjs/toolkit/query/react'
import type { FetchArgs } from '@reduxjs/toolkit/query'
import { AxiosRequestConfig } from 'axios'

export const baseApi = createApi({
  tagTypes: [
    'SalaryCardList',
    'SalaryCardStatusList',
    'TrustedPersonList',
    'BusinessCardLimitInfo',
    'BusinessCardList',
    'BusinessCardStatusList',
    'BusinessCardQhtStatus',
  ],
  reducerPath: 'api',
  refetchOnMountOrArgChange: true,
  baseQuery: retry(
    async (
      args:
        | {
            isGw?: boolean
            file?: 'upload' | 'download' | 'none'
            skipGlobalError?: boolean
            url: string
            throwable?: boolean
            method?: AxiosRequestConfig['method']
            data?: AxiosRequestConfig['data']
            params?: AxiosRequestConfig['params']
            headers?: AxiosRequestConfig['headers']
          }
        | FetchArgs,
      api,
      extraOptions
    ) => {
      const result = await axiosBaseQuery()(args, api, extraOptions)

      if (result.error?.status < 500) {
        retry.fail(result.error, result.meta)
      }

      return result
    },
    { maxRetries: 3 }
  ),
  endpoints: () => ({}),
})
